// extracted by mini-css-extract-plugin
export var brand = "_8w-9";
export var compact = "_8w-6";
export var extraSmall = "_8w-7";
export var icon = "_8w-0";
export var large = "_8w-4";
export var light = "_8w-1";
export var medium = "_8w-5";
export var outline = "_8w-b";
export var primaryDark = "_8w-a";
export var primaryLight = "_8w-8";
export var primaryModern = "_8w-c";
export var success = "_8w-2";
export var successSolid = "_8w-3";